import React from "react";

import Lottie from "react-lottie";
import profileLottie from "../../assets/lotties/profileCircle2.json";
import { ProfileImage,IntroImageContainer } from "./introImage.styles";

const IntroImage = () => {
  const profileLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: profileLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <IntroImageContainer>
      <Lottie options={profileLottieOptions} width="100%" height="100%" />
      <ProfileImage url="https://wallpaperaccess.com/full/4525391.jpg" />

    </IntroImageContainer>
  );
};

export default IntroImage;
